import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useManagedAccountPageContext,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Context/ManagedAccountPageContext';
import TabNotFoundLayout
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/TabNotFoundLayout';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import BalanceAndAllocationTabPanelLayout
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/BalanceAndAllocationTabPanelLayout/';
import ManagedAccountTransactionTabPanelLayout
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/ManagedAccountTransactionTabPanelLayout/';
import ManagedAccountDocuments
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/ManagedAccountDocuments';
import ManagedAccountInfoTabPanelLayout
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountPageTabPanel/Layouts/ManagedAccountInfoTabPanelLayout';
import AccountPerformanceDashboard from './Layouts/AccountPerformanceDashboard';

const TAB_MAP = {
  BalanceAndAllocation: {
    Layout: BalanceAndAllocationTabPanelLayout,
    metaOverrideSet: undefined,
  },
  TabNotFound: {
    Layout: TabNotFoundLayout,
    metaOverrideSet: undefined,
  },
  Transactions: {
    Layout: ManagedAccountTransactionTabPanelLayout,
    metaOverrideSet: undefined,
  },
  Performance: {
    Layout: AccountPerformanceDashboard,
  },
  Documents: {
    Layout: ManagedAccountDocuments,
    metaOverrideSet: undefined,
  },
  AccountInfo: {
    Layout: ManagedAccountInfoTabPanelLayout,
    metaOverrideSet: undefined,
  },
};

const getTabLayout = (tabKey) => {
  const tab = TAB_MAP[tabKey];
  if (!tab) {
    return TAB_MAP.TabNotFound;
  }
  return tab;
};

const useStyles = buildUseStyles('ManagedAccountPageTabPanel', () => ({
  root: {
    flexGrow: 1,
    width: '100%',
    padding: 0,
    backgroundColor: 'inherit',
  },
}));

const ManagedAccountPageTabPanel = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { currentTab, currentTabResource } = useManagedAccountPageContext();

  // If there is no currentTabResource return TabNotFound.
  // Can be used here to show a skeleton or Data Container if preferred.
  if (!currentTab) {
    return (
      <TabNotFoundLayout className={classNames(className, classes.root)} />
    );
  }

  const { Layout, metaOverrideSet } = getTabLayout(currentTab);


  return (
    <MetaFormInline
      className={classNames(className, classes.root)}
      noIndividualSubmitButtons
      resource={currentTabResource}
      layout={Layout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

ManagedAccountPageTabPanel.defaultProps = {
  className: '',
};

ManagedAccountPageTabPanel.propTypes = {
  className: PropTypes.string,
};

export default ManagedAccountPageTabPanel;
